import React from 'react';
import classes from "./BaseSimpleItemEditorForm.module.css";

const BaseSimpleItemEditorForm = ({children}) => {
    return (
        <div className={classes.main}>
            {children}
        </div>
    );
};

export default BaseSimpleItemEditorForm;